import { render, staticRenderFns } from "./FacturarPage.vue?vue&type=template&id=6d81b7ba&scoped=true"
import script from "./FacturarPage.vue?vue&type=script&lang=js"
export * from "./FacturarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d81b7ba",
  null
  
)

export default component.exports